import React from 'react'
import axios from 'axios'
import qs from 'qs'
import { useSelector, useDispatch } from 'react-redux'
import { useRequest } from '@/hooks/useRequest'
import { Margin } from '../Margin'
import { ChangeStructure } from './ChangeStructure'
import { Constructor } from './Constructor'
import { FullStructure } from './FullStructure'
import { Wrapper } from './style'
import { changeStructure, setPimStruct } from '../../actions'
import { Loader } from '@/components/Loader'

export const Pim = ({ isGeneral, subjectName }) => {
  const dispatch = useDispatch()
  const { pimId, activeStructure, isConstructor } = useSelector((state: any) => state)

  const [data, isLoading] = useRequest({
    url: '/fgos_pim_struct/getPimStruct',
    body: { pimId },
    then: !!pimId,
    onSuccess: (resData) => dispatch(setPimStruct(resData))
  }, [pimId])

  const takePrintVersion = async (topics, modules, cases, ref) => {
    const dataObj = {
      block_topics: topics.map(i => ({ name: i.name })),
      block_modules: modules.map(i => ({ name: i.name })),
      block_cases: cases.map(i => ({
        name: i.name,
        block_subtasks: i.topics.map(t => ({ name: t.name }))
      }))
    }

    const response = await axios.post(
      '/fgos_pim_struct/getPrintedVersion',
      qs.stringify({
        fileData: JSON.stringify(dataObj)
      }),
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
        }
      }
    )

    const fileName = `${subjectName} (Содержание ПИМ).docx`
    ref.current.href = URL.createObjectURL(response.data)
    ref.current.download = fileName
    ref.current.click()
  }

  if (!data && !isLoading) return null
  if (isLoading) return <Loader />

  return (
    <Wrapper>
      <h4 className="text-center">Содержание педагогических измерительных материалов (ПИМ)</h4>
      {isConstructor &&
        <ChangeStructure
          activeStructure={activeStructure}
          changeStructure={(value) => dispatch(changeStructure(value))}
        />
      }

      <Margin top=''>
        {activeStructure === 'constructor'
          ? <Constructor
            pimData={data}
            takePrintVersion={takePrintVersion} />
          : <FullStructure
            isGeneral={isGeneral}
            pimData={data}
            takePrintVersion={takePrintVersion} />
        }
      </Margin>
    </Wrapper>
  )
}

